import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var pilatesIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.705 3.763c.517.874.452 2.492-.322 2.95-.348.204-.85.188-1.399-.034-.562-.228-1.078-.65-1.344-1.1a1.768 1.768 0 0 1-.192-1.35 1.765 1.765 0 0 1 1.096-1.225c.794-.3 1.714.005 2.161.76m.387 4.147c1.511-.896 1.678-3.39.81-4.857a3.177 3.177 0 0 0-4.346-1.113A3.145 3.145 0 0 0 1.1 3.884a3.156 3.156 0 0 0 .343 2.404c.42.71 1.175 1.338 2.018 1.68.806.327 1.612.364 2.274.114a2.34 2.34 0 0 0 .357-.17m14.378 14.18H5.095a1.5 1.5 0 0 1 1.5-1.5H18.97a1.5 1.5 0 0 1 1.5 1.5m-8.548-4.662a.434.434 0 0 1-.347-.187L7.11 11.01c-.08-.116-.057-.28-.01-.322l.902-.584 4.67 6.392-.433.81c-.113.112-.236.138-.316.125m9.77-13.463-4.875 5.125.008.01c-.33.376-1.045 1.587-3.37 5.925l-4.068-5.57 2.081-.627c.262-.074 1.175-.384 4.865-1.788a1.503 1.503 0 0 0 .871-1.938c-2.164.828-5.736 2.178-6.063 2.267l-2.49.75a2.349 2.349 0 0 0-.88.343L6.224 9.471a1.78 1.78 0 0 0-.343 2.4l4.476 6.246c.358.5.914.796 1.523.813h.056c.588 0 1.135-.262 1.507-.726l.08-.117c1.86-3.496 3.992-7.413 4.366-7.946l3.854-4.053a1.5 1.5 0 0 0-.05-2.12",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { pilatesIcon as default };
//# sourceMappingURL=pilatesIcon.js.map
